import * as React from "react";
import styleable from "react-styleable";
import * as style from '../../../css/components/mainlayout/Loading.css';

/**
 * **Styleable**
 * Set ripple color with `.ripple div` border-color.
 */
class Loading extends React.Component<any, any> {

    render() {
        return (
            <div style={{display: 'flex', flex: 1, flexDirection: 'column', height: "100%"}}>
                <div className={this.props.css.container}><div className={this.props.css.ripple}><div></div><div></div></div></div>
            </div>
        );
    }
}
export default styleable(style)(Loading);